// 后端 API 地址，本地开发用空字符串，线上部署填后端域名
const BACKEND_URL = ''

// ── 设备检测 ──────────────────────────────────────────────────────────────────
export const isCarDevice = (): boolean => {
  const ua = navigator.userAgent
  return /Tesla|Desktop/i.test(ua)
}

export const deviceMode = (): 'car' | 'web' => {
  return isCarDevice() ? 'car' : 'web'
}

async function request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
  const url = BACKEND_URL ? `${BACKEND_URL}${endpoint}` : endpoint
  const res = await fetch(url, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }))
    throw new Error(err.detail || `HTTP ${res.status}`)
  }
  return res.json()
}

export const api = {
  // ── 健康检查（含设备信息） ───────────────────────────────────────────────────
  health: () => request<{ status: string; device: string; version: string }>('/health'),

  // ── 导入管理 ─────────────────────────────────────────────────────────────────
  importFiles: async (files: File[], folderName: string = '') => {
    const form = new FormData()
    files.forEach(f => form.append('files', f))
    form.append('folder_name', folderName)
    const url = BACKEND_URL ? `${BACKEND_URL}/api/edit/upload` : '/api/edit/upload'
    const res = await fetch(url, { method: 'POST', body: form })
    if (!res.ok) {
      const err = await res.json().catch(() => ({ detail: res.statusText }))
      throw new Error(err.detail || `HTTP ${res.status}`)
    }
    return res.json()
  },

  scanFolder: (folderPath: string) => request('/folders/scan', {
    method: 'POST',
    body: JSON.stringify({ folder_path: folderPath }),
  }),
  listVideos: (dateFilter?: string, limit = 100) =>
    request(`/videos?date_filter=${dateFilter || ''}&limit=${limit}`),

  // ── 视频流 ───────────────────────────────────────────────────────────────────
  getVideoStream: (id: string) =>
    `${BACKEND_URL ? BACKEND_URL : ''}/api/videos/${id}/stream`,

  getVideo: (id: string) => request(`/videos/${id}`),
  deleteVideo: (id: string) => request(`/videos/${id}`, { method: 'DELETE' }),

  // ── 剪辑编辑 ─────────────────────────────────────────────────────────────────
  cropVideo: (data: {
    video_id: string; start_time: number; end_time: number;
    output_filename?: string;
    watermark_text?: string; watermark_font_size?: number;
    watermark_position?: string; watermark_font_color?: string;
  }) => request('/edit/crop', { method: 'POST', body: JSON.stringify(data) }),

  mergeVideos: (data: { video_ids: string[]; output_filename?: string }) =>
    request('/edit/merge', { method: 'POST', body: JSON.stringify(data) }),

  rotateVideo: (data: { video_id: string; degrees: number; output_filename?: string }) =>
    request('/edit/rotate', { method: 'POST', body: JSON.stringify(data) }),

  exportVideo: (data: {
    video_id: string; format?: string; resolution?: string;
    output_filename?: string;
    watermark_text?: string; watermark_font_size?: number;
    watermark_position?: string; watermark_font_color?: string;
  }) => request('/edit/export', { method: 'POST', body: JSON.stringify(data) }),

  // ── 导出任务 ─────────────────────────────────────────────────────────────────
  listTasks: (limit = 50) => request(`/export/tasks?limit=${limit}`),
  cancelTask: (taskId: string) => request(`/export/tasks/${taskId}`, { method: 'DELETE' }),

  // 触发下载（浏览器直接下载文件）
  downloadExport: (taskId: string): void => {
    const base = BACKEND_URL || ''
    const a = document.createElement('a')
    a.href = `${base}/api/export/tasks/${taskId}/download`
    a.download = ''
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  },

  // 标记为已下载（供后台清理）
  markDownloaded: (taskId: string) =>
    request(`/export/tasks/${taskId}/cleanup`, { method: 'POST' }),
}
